'use strict';

import ngResource from 'angular-resource';

class OemService {
  constructor($resource) {
    'ngInject';

    this.api = $resource(
      '/api/oem/:id',
      {id: '@id'},
      {
        index: {method: 'GET', isArray: false}
      }
    );
    this.oem_api = $resource(
      '/api/oem/oem/:id',
      {id: '@id'},
      {
        index: {method: 'GET', isArray: false}
      }
    );
    this.manage_api = $resource(
      '/:mode/api/oem/:id',
      { id: '@id', mode: '@mode' },
      {
        index: {method: 'GET', isArray: true},
        show  : { method: 'GET',  isArray: false },
        update: { method: 'PUT',  isArray: false }
      }
    );
  }
}

export default angular.module('leptonApp.OemService', ['ngResource'])
  .service('OemService', ['$resource', OemService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/oem/oem.service.js